import pathsManifest from '../../pathsManifest';

const defaultContext = {
  brand: 'zillow',
  isInMobileWebView: false,
  isLayoutHorizontal: false,
  paths: pathsManifest.getAllPaths('zillow'),
};

export default defaultContext;
